import { Filters } from "@volt_developers/components";
import { ReactNode } from "react";

import { Actions } from "./Actions";
import { useFiltersModal } from "./useFiltersModal";

interface FiltersModalProps {
  areFiltersInitialAndDefaultDifferent: boolean;
  areFiltersTheSameAsInitial: boolean;
  children: ReactNode;
  "data-testid": string;
  handleApply: VoidFunction;
  handleClickAway: VoidFunction;
  handleClose: VoidFunction;
  handleReset: VoidFunction;
  isActive: boolean;
  areFiltersInvalid?: boolean;
}

export function FiltersModal({
  isActive,
  areFiltersTheSameAsInitial,
  areFiltersInitialAndDefaultDifferent,
  children,
  "data-testid": dataTestId,
  handleClose,
  handleReset,
  handleApply,
  handleClickAway,
  areFiltersInvalid,
}: FiltersModalProps) {
  useFiltersModal(isActive);

  return (
    <Filters.Wrapper
      data-testid={dataTestId}
      isActive={isActive}
      sx={{ width: FILTERS_MODAL_WIDTH, pointerEvents: "auto" }}
      onClickAway={handleClickAway}
    >
      {children}
      <Filters.Separator />
      <Actions
        areFiltersInvalid={areFiltersInvalid}
        areFiltersTheSameAsInitial={areFiltersTheSameAsInitial}
        areFiltersInitialAndDefaultDifferent={
          areFiltersInitialAndDefaultDifferent
        }
        handleApply={handleApply}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </Filters.Wrapper>
  );
}

const FILTERS_MODAL_WIDTH = 571;
